import { ProductType } from '../types'

export const getProductType = (type: ProductType) => {
  switch (type) {
    case ProductType.INVENTORY:
      return 'İnventar'
    case ProductType.PRODUCT:
      return 'Məhsul'
    default:
      return ''
  }
}
